export default function Success({ message }) {
  return <div style={{ color: "#1168db" }}>{message}</div>;
}
